import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { LoadType } from '../../models/load-type';

@Injectable({
  providedIn: 'root',
})
export class LoadTypeService {
  currentDomain = environment.currentApiHostname
  apiUrl = `https://${this.currentDomain}/api/general`;


  constructor(private http: HttpClient) {}

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
        `/load-types?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }



  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<LoadType>>(
      this.apiUrl +  `/load-types/index/all`,
      options
    );
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };


    return this.http.get(
      this.apiUrl +
        `/exports/load-types/export/${type}?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }


  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<LoadType>(
      this.apiUrl +  `/load-types/${uuid}`,
      options
    );
  }

  store(category: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<LoadType>(
      this.apiUrl +  `/load-types`,
      category,
      options
    );
  }

  update(category: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<LoadType>(
      this.apiUrl +  `/load-types/update/${uuid}`,
      category,
      options
    );
  }
}
